export { AtnReportTableCellComponent as Component } from './report-table-cell.component'
